const encodeBazaarVoiceContent = str => {
  if (str) {
    return str
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#x27;')
      .replace(/\//g, '&#x2F;')
  }
  return str
}

export default encodeBazaarVoiceContent
